import { ILang } from "../../i18n/ILang";
import { NavState } from "../../Nav/reducer";
import {
  all as en,
  freeTrial as freeTrialEN,
  becomeMemberPayment as becomeMemberPaymentEN,
  login as loginEN,
  logout as logoutEN,
  myAccount as myAccountEN,
  shoppingList as shoppingListEN,
  tracking as trackingEN,
  appCta as appCtaEN,
  stores as storesEN
} from "./en";
import {
  all as es,
  freeTrial as freeTrialES,
  becomeMemberPayment as becomeMemberPaymentES,
  login as loginES,
  logout as logoutES,
  myAccount as myAccountES,
  tracking as trackingES,
  shoppingList as shoppingListES,
  appCta as appCtaES,
  stores as storesES
} from "./es";
import {
  all as sv,
  freeTrial as freeTrialSV,
  becomeMemberPayment as becomeMemberPaymentSV,
  login as loginSV,
  logout as logoutSV,
  myAccount as myAccountSV,
  tracking as trackingSV,
  shoppingList as shoppingListSV,
  appCta as appCtaSV,
  stores as storesSV
} from "./sv";

export const data = {
  all: {
    en,
    es,
    sv
  },
  myAccount: {
    en: myAccountEN,
    es: myAccountES,
    sv: myAccountSV
  },
  freeTrial: {
    en: freeTrialEN,
    es: freeTrialES,
    sv: freeTrialSV
  },
  becomeMemberPayment: {
    en: becomeMemberPaymentEN,
    es: becomeMemberPaymentES,
    sv: becomeMemberPaymentSV
  },
  login: {
    en: loginEN,
    es: loginES,
    sv: loginSV
  },
  logout: {
    en: logoutEN,
    es: logoutES,
    sv: logoutSV
  },
  shoppingList: {
    en: shoppingListEN,
    es: shoppingListES,
    sv: shoppingListSV
  },
  tracking: {
    en: trackingEN,
    es: trackingES,
    sv: trackingSV
  },
  appCta: {
    en: appCtaEN,
    es: appCtaES,
    sv: appCtaSV
  },
  stores: {
    en: storesEN,
    es: storesES,
    sv: storesSV
  }
};

export function menuWithLang(lang: ILang): NavState["menuItems"] {
  return {
    all: data.all[lang],
    freeTrial: data.freeTrial[lang],
    becomeMemberPayment: data.becomeMemberPayment[lang],
    login: data.login[lang],
    logout: data.logout[lang],
    myAccount: data.myAccount[lang],
    tracking: data.tracking[lang],
    shoppingList: data.shoppingList[lang],
    appCta: data.appCta[lang],
    stores: data.stores[lang]
  };
}
